import { Injectable, NgZone } from '@angular/core';
import { User } from "./user";
import { auth } from 'firebase/app';
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Router } from "@angular/router";
import { throwError, Observable } from 'rxjs';

import { MessageService } from './messages.service';
import { switchMap, first, map } from 'rxjs/operators';

declare var gapi: any

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  userData: any; // Save logged in user data
  userRole: any;
  adminContent: boolean;
  user$: Observable<User>;


  constructor(
    public afs: AngularFirestore,   // Inject Firestore service
    public afAuth: AngularFireAuth, // Inject Firebase auth service
    public router: Router,  
    public ngZone: NgZone, // NgZone service to remove outside scope warning
    private messageService: MessageService
  ) {
    /* Saving user data in localstorage when 
    logged in and setting up null when logged out */
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.userData = user;
        localStorage.setItem('user', JSON.stringify(this.userData));
        JSON.parse(localStorage.getItem('user'));
      } else {
        localStorage.setItem('user', null);
        JSON.parse(localStorage.getItem('user'));
      }
    })
    {
      this.user$ = this.afAuth.authState.pipe(
        switchMap(user => {
          if (user) {
            return this.afs.doc<any>(`users/${user.uid}`).valueChanges();
          } else {
            
          }
        })
      );
    }
  }
  
  getUser() {
    return this.user$.pipe(first()).toPromise();
  }

  // Sign in with email/password
  SignIn(email, password) {
    return this.afAuth.auth.signInWithEmailAndPassword(email, password)
      .then((result) => {
        this.messageService.clear();
        this.ngZone.run(() => {
          this.router.navigate(['dashboard']);
        });
        this.SetUserData(result.user);
        if (result.user.emailVerified == false){
          this.messageService.add("Email address: " + result.user.email + " has not been verified yet. Check your inbox.");
        }
        console.log(result.user.emailVerified);
      }).catch((error) => {
        this.messageService.clear();
        console.log(error.message);
        this.messageService.add(error.message);
      })
  }


  // Sign up with email/password
  SignUp(name, email, password, photourl) {
    return this.afAuth.auth.createUserWithEmailAndPassword(email, password)
      .then((result) => {
        /* Call the SendVerificaitonMail() function when new user sign 
        up and returns promise */
        this.messageService.clear();
        this.SendVerificationMail();
        this.SetUserData(result.user);
        console.log(result.user.uid)
        console.log(result.user.displayName)
        result.user.updateProfile({
          displayName: name,
          photoURL: photourl
        })
      }).catch((error) => {
        this.messageService.clear();
        console.log(error.message);
        this.messageService.add(error.message);
      })
  }

  // Send email verfificaiton when new user sign up
  SendVerificationMail() {
    return this.afAuth.auth.currentUser.sendEmailVerification()
    .then(() => {
      this.router.navigate(['verify-email-address']);
    })
  }

  // Reset Forggot password
  ForgotPassword(passwordResetEmail) {
    return this.afAuth.auth.sendPasswordResetEmail(passwordResetEmail)
    .then(() => {
      this.messageService.clear();
      this.messageService.add('Password reset email sent, check your inbox.');
    }).catch((error) => {
      this.messageService.clear();
      console.log(error.message);
      this.messageService.add(error.message);
    })
  }

  // Returns true when user is logged in and email is verified
  get isLoggedIn(): boolean {
    const user = JSON.parse(localStorage.getItem('user'));
    return (user !== null && user.emailVerified !== false) ? true : false;
  }

  // Sign in with Google
  GoogleAuth() {
    return this.AuthLogin(new auth.GoogleAuthProvider());
  }

  // Auth logic to run auth providers
  AuthLogin(provider) {
    return this.afAuth.auth.signInWithPopup(provider)
    .then((result) => {
       this.ngZone.run(() => {
          this.router.navigate(['dashboard']);
        })
      this.SetUserData(result.user);
    }).catch((error) => {
      this.messageService.clear();
      console.log(error.message);
      this.messageService.add(error.message);
    })
  }

  /* Setting up user data when sign in with username/password */
  SetUserData(user) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const data: User = {
      uid: user.uid,
      email: user.email,
      roles: {
        employee: true,
        manager: true,
        admin: true
      },
      displayName: user.displayName,
      photoURL: user.photoURL,
      emailVerified: user.emailVerified
    }
    return userRef.set(data, {merge: true})
  }

  // Update User Data
  UpdateUserData(user) {
    const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
    const data: User = {
      uid: user.uid,
      email: user.email,
      roles: {
        employee: true
      },
      displayName: user.displayName,
      photoURL: "https://media-exp1.licdn.com/dms/image/C4D03AQHkTd53_Bdcwg/profile-displayphoto-shrink_100_100/0?e=1593043200&v=beta&t=WctbMpjBnD2kd9BmlpsKZ1nVAqjomLoeDOg2p1KnsJs",
      emailVerified: user.emailVerified
    }
    return userRef.set(data, {merge: true})
  }

  // Sign out 
  SignOut() {
    return this.afAuth.auth.signOut().then(() => {
      localStorage.removeItem('user');
      this.router.navigate(['sign-in']);
    })
  }

  // Role Based Function and Abilities //
  // Assign roles to an ability //
  ///// Role-based Authorization //////

 canRead(user: User): boolean {
  const allowed = ['admin', 'editor', 'subscriber']
  return this.checkAuthorization(user, allowed)
}

  canEdit(user: User): boolean {
    const allowed = ['admin', 'editor']
    return this.checkAuthorization(user, allowed)
  }

  canDelete(user: User): boolean {
    const allowed = ['admin']
    return this.checkAuthorization(user, allowed)
  }

  //is Admin
  isAdmin(userId){
    const docRef = this.afs.collection('users').doc(userId);
    return docRef.valueChanges()
    .subscribe(data => {
      this.userRole = data;
      if(this.userRole.roles.admin == true){
        this.adminContent = true;
      }else{
        this.adminContent = false;
      }
      }
    );
  }


// determines if user has matching role
private checkAuthorization(user: User, allowedRoles: string[]): boolean {
  if (!user) return false
  for (const role of allowedRoles) {
    if ( user.roles[role] ) {
      return true
    }
  }
  return false
}
  
}